import {$, w} from './constants';
'use strict';

var $cal, $modal, currentTerm = 'todo';

function boot(){
    if (!$('#calendar_events_widget').length) return;
    $cal   = $('#gbmCalendar');
    $modal = $('#gbmCalendarModal');

    $cal.on('click', '.cal__nav', onNavMonth);
    $cal.on('click', '.cal__filter', onFilter);
    $cal.on('click', '.cal__cell.has-events', onOpenDay);

    $modal.on('click', '.calmodal__overlay, .daymodal__close', closeModal);
    $modal.on('click', '.daymodal__nav', onNavDay);

    toggleMonthArrows();
}

function onFilter(e){
    e.preventDefault();
    var $b = $(this);
    currentTerm = $b.data('term') || 'todo';
    $b.addClass('is-active').siblings().removeClass('is-active');

    var $grid = $('.cal__grid', $cal);
    loadMonth(parseInt($grid.data('year'),10), parseInt($grid.data('month'),10), currentTerm);
}

function onNavMonth(e){
    e.preventDefault();

    if ($(this).prop('disabled') || $(this).hasClass('is-disabled')) return;

    var dir = parseInt($(this).data('dir'),10);
    var $grid = $('.cal__grid', $cal);
    var y = parseInt($grid.data('year'),10);
    var m = parseInt($grid.data('month'),10);

    m += dir;
    if (m < 1 || m > 12) return;

    loadMonth(y, m, currentTerm);
}

function onOpenDay(e){
    e.preventDefault();
    var day = $(e.currentTarget).data('day');
    $.ajax({
            url: cltvo_js_vars.ajax_url,
            method: 'POST',
            data: {
            action: 'load_webinars_day',
            day: day,
            term: currentTerm
        },
        dataType: 'html',
        success: function(html){
            $('.calmodal__body', $modal).html(html);
            $modal.removeAttr('hidden');
            $('body').addClass('is-modal-open');
            toggleDayArrows();
        }
    });
}

function onNavDay(e){
    e.preventDefault();
    var dir = parseInt($(this).data('dir'),10);
    var $dm = $('.daymodal', $modal);
    var currentYmd = String($dm.data('day'));
    var year  = parseInt($dm.data('year'),10);
    var month = parseInt($dm.data('month'),10);
    var days  = parseInt($dm.data('days'),10);

    var next = addDaysYmd(currentYmd, dir);
    var nY = parseInt(next.slice(0,4),10);
    var nM = parseInt(next.slice(4,6),10);
    var nD = parseInt(next.slice(6,8),10);
    if (nY !== year || nM !== month || nD < 1 || nD > days) return;

    $.ajax({
            url: cltvo_js_vars.ajax_url,
            method: 'POST',
            data: {
            action: 'load_webinars_day',
            nonce: cltvo_js_vars.nonce,
            day: next,
            term: currentTerm
        },
        dataType: 'html',
        success: function(html){
            $('.calmodal__body', $modal).html(html);
            toggleDayArrows();
        }
    });
}

function closeModal(){
    $modal.attr('hidden', true);
    $('.calmodal__body', $modal).empty();
    $('body').removeClass('is-modal-open');
}

function loadMonth(year, month, term){
    $cal.addClass('is-loading');
    $.ajax({
        url: cltvo_js_vars.ajax_url,
        method: 'POST',
        data: {
        action: 'load_webinars_month',
        year: year,
        month: month,
        term: term || 'todo'
        },
        dataType: 'html',
        success: function(html){
        $cal.removeClass('is-loading').html(html);
        toggleMonthArrows();
        },
        error: function(){ $cal.removeClass('is-loading'); }
    });
}

function ymdToDate(ymd){
  return new Date(
    parseInt(ymd.slice(0,4),10),
    parseInt(ymd.slice(4,6),10)-1,
    parseInt(ymd.slice(6,8),10)
  );
}
function dateToYmd(date){
  var y = date.getFullYear();
  var m = String(date.getMonth()+1).padStart(2,'0');
  var d = String(date.getDate()).padStart(2,'0');
  return ''+y+m+d;
}
function addDaysYmd(ymd, delta){
  var dt = ymdToDate(ymd);
  dt.setDate(dt.getDate()+delta);
  return dateToYmd(dt);
}

function toggleDayArrows(){
  var $dm  = $('.daymodal', $modal);
  if(!$dm.length) return;
  var day  = parseInt(String($dm.data('day')).slice(6,8),10);
  var days = parseInt($dm.data('days'),10);
  $('.daymodal__nav--prev', $modal).prop('disabled', day <= 1);
  $('.daymodal__nav--next', $modal).prop('disabled', day >= days);
}

function toggleMonthArrows(){
    var $grid = $('.cal__grid', $cal);
    if(!$grid.length) return;

    var m = parseInt($grid.data('month'),10);

    var $prev = $('.cal__nav[data-dir="-1"]', $cal);
    var $next = $('.cal__nav[data-dir="1"]', $cal);

    var disablePrev = m <= 1;
    var disableNext = m >= 12;

    $prev.prop('disabled', disablePrev).toggleClass('is-disabled', disablePrev).attr('aria-disabled', disablePrev);
    $next.prop('disabled', disableNext).toggleClass('is-disabled', disableNext).attr('aria-disabled', disableNext);
}

$(boot);